var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var PropBagAnimation = require("clover/panel/component/bagpanel/PropBagAnimation")
let SnsProxy = require("clover/sns/SnsProxy")
require("clover/data/ItemDataManager")
/**
 * 该面板主要用于关前道具购买展示和操作
 */
var StartBuyPropPanel = xClass("StartBuyPropPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/frame_purchase2_frame_purchase.csb")
})
let preload_res = []
let extra_plist = "cocos/frame_purchase2.plist"
/**
 * 显示关前道具面板
 * @param prop  道具信息
 * @param flag  是否背景变黑
 * @param onCloseCallback   关闭回调
 */
StartBuyPropPanel.show = function (prop, flag, onCloseCallback,onFailCallback) {
    function callback() {
        let propData = table()
        for (let i = 0; i < prop.length; i++) {
            propData[(i + 1)] = ItemDataManager.getItemDataById(prop[i])
        }
        var _panel = StartBuyPropPanel.create(propData, onCloseCallback)
        //_panel.setAnchorPoint(0, 0)
        _panel.popup(flag)
    }
    function onFail() {
        Toast.make(getText("error.tip.timeout"))
        onFailCallback && onFailCallback()
    }
    preload_res = [
		"packed/StartBuyPropPreloadConfig.pack"
	];
    if (!cc.loader.getRes(getRealResourceName(extra_plist))) {
        preload_res.push(extra_plist)
    }
    let preload_list = buildResList(preload_res)
    preloadWithLoading(preload_list, callback, onFail,onFail)
}
/**
 * 构造函数
 * @param propData  道具数据
 * @param onCloseCallback   关闭回调
 */
StartBuyPropPanel.prototype.ctor = function (propData, onCloseCallback) {
    var self = this

    self.propId = propData[1].propId                //  道具编号
    self.itemId = propData[1].id
    self.discountPropId = propData[2].propId   
    self.discountItemId = propData[2].id     
    self.price = propData[1].price                  //  售价
    self.discountPrice = propData[2].price
    self.payType = propData[1].payType              //  货币种类
    self.discountPayType = propData[2].payType
    self.num = propData[1].num                      //  道具数量
    self.discountNum = propData[2].num
    self.discount = propData[2].discount
    self.onCloseCallback = onCloseCallback
    self.isBusy = false
    //self.onConfirm = confirmCallback
    //self.onCancel = cancelCallback
    self.init()
}
/**
 * 初始化面板
 */
StartBuyPropPanel.prototype.init = function () {
    var self = this

    BasePanel.prototype.init.call(self)
    let anchor = self.getAnchorPoint()
    self.setAnchorPoint(cc.p(-0.02, 0.13))

    //  单个道具购买按钮
    self.buyBtn = self.getChildByName("btn_blue_consume1")
    self.buyBtn = UIButton.create(self.buyBtn)
    self.buyBtn.on(UIButtonEvent.Click, function() {
        self.onConfirmBuyProp()
    })
    ButtonPushBounceAnim.create(self.buyBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.buyBtn)
    //  多个道具打折购买按钮
    self.discountBtn = self.getChildByName("btn_blue_consume2")
    self.discountBtn = UIButton.create(self.discountBtn)
    self.discountBtn.on(UIButtonEvent.Click, function () {
        self.onConfirmBuyDiscountProp()
    })
    ButtonPushBounceAnim.create(self.discountBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.discountBtn)

    //  面板关闭按钮
    self.closeBtn = UIButton.create(self.getChildByName("btn_panel_close3"))
    self.closeBtn.on(UIButtonEvent.Click, function () {
        self.onCloseClicked()
    })

    //  道具标签
    self.prop = self.getChildByName("bubble_props")
    self.discountProp = self.getChildByName("bubble_props_discount")

    //  优惠标签
    self.discountTip = self.getChildByName("tip_discount")
    let txt = self.discountTip.getChildByName("txt")
    txt.setFontWeight("bold")
    txt.ignoreContentAdaptWithSize(true)
    txt.setPosition(cc.p(txt.getPositionX() + 8, txt.getPositionY() + 8))
    txt.setRotation(-45)
    self.discountLabel = self.getChildByName("label_discount")
    let num = self.discountLabel.getChildByName("num")
    num.ignoreContentAdaptWithSize(true)
    let disNum = Math.floor(self.discount * 100) / 10
    let disLabelNeedMove = false
    if (disNum > 10) {
        self.discountLabel.setVisible(false)
    } else if (disNum - Math.floor(disNum) > 0) {
        //  带小数点，打折标签需要移动字体位置
        disLabelNeedMove = true
    }
    num.setString(disNum)
    num.setRotation(30)
    if (disLabelNeedMove) {
        num.setPosition(cc.p(num.getPositionX() - 2, num.getPositionY()))
    } else {
        num.setPosition(cc.p(num.getPositionX() + 7, num.getPositionY() - 6))
    }
    let discountTxt = self.discountLabel.getChildByName("txt")
    discountTxt.setFontWeight("bold")
    discountTxt.ignoreContentAdaptWithSize(true)
    discountTxt.setRotation(30)
    if (disLabelNeedMove) {
        discountTxt.setPosition(cc.p(discountTxt.getPositionX() + 7, discountTxt.getPositionY() - 10))
    }  else {
        discountTxt.setPosition(cc.p(discountTxt.getPositionX() - 2, discountTxt.getPositionY() - 4))
    }

    //  标题
    self.title = self.getChildByName("title")
    self.title.setAnchorPoint(0.5, self.title.getAnchorPoint().y)
    self.title.setPositionX(self.getContentSize().width / 2)
    self.title.ignoreContentAdaptWithSize(true)
    self.title.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    let titleStr = getText("buy.props.title", table([1, "goodsId", getText("prop.name." + tostring(self.propId))]))
    if (SnsProxy.getInstance().isBuyBan()) {
        titleStr = titleStr.replace(getText("buy.out.buyban"), getText("buy.in.buyban"))
    }
    self.title.setString(titleStr)
    
    //  提示信息
    self.tip = self.getChildByName("txt")
    self.tip.setAnchorPoint(0.5, self.tip.getAnchorPoint().y)
    self.tip.setPositionX(self.getContentSize().width / 2 - 10)
    self.tip.ignoreContentAdaptWithSize(true)
    self.tip.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    let string = getText("buy.props.description." + self.propId)
    if (SnsProxy.getInstance().isBuyBan()) {
        string = string.replace(getText("buy.out.buyban"), getText("buy.in.buyban"))
    }
    self.tip.setString(string)
    //self.tip.setFontWeight("bold")
    if (string.indexOf("\n") >= 0) {
        self.tip.setPositionY(self.tip.getPositionY() + self.tip.getContentSize().height / 4)
    }
    self.originScale = self.getScale(0)

    //  设置道具标签
    self.buildProp()
}
/**
 * 设置道具标签
 */
StartBuyPropPanel.prototype.buildProp = function () {
    var self = this

    //  设置道具图标
    let prop = self.prop.getChildByName("props_refresh")
    prop.setPosition(cc.p(prop.getPositionX() - 1, prop.getPositionY() - 4))
    prop.setSpriteFrame(UIItemBuilder.createPropIcon(self.propId).getSpriteFrame())
    for (let i = 1; i < 4; i++) {
        var disProp = self.discountProp.getChildByName("props_" + i)
        disProp.setPosition(cc.p(disProp.getPositionX() - 1, disProp.getPositionY() - 4))
        disProp.setSpriteFrame(UIItemBuilder.createPropIcon(self.propId).getSpriteFrame())
    }
    //  设置道具数量
    var num = self.prop.getChildByName("num")
    var disNum = self.discountProp.getChildByName("num")
    num.setString("x" + self.num)
    num.setNextFontPositionXOffset(-5)
    num.setPosition(cc.p(num.getPositionX() + 17, num.getPositionY() - 25))
    disNum.setString("x" + self.discountNum)
    disNum.setNextFontPositionXOffset(-5)
    disNum.setPosition(cc.p(disNum.getPositionX() + 17, disNum.getPositionY() - 25))
    //  设置道具价格
    var label = self.buyBtn.getChildByName("label")
    label.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    label.setString(self.price)
    label.ignoreContentAdaptWithSize(true)
    label.setNextFontPositionXOffset(-2)
    var disLabel = self.discountBtn.getChildByName("label")
    disLabel.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    disLabel.setString(self.discountPrice)
    disLabel.ignoreContentAdaptWithSize(true)
    disLabel.setNextFontPositionXOffset(-2)
    //  设置货币种类
    self.buildPayType(self.buyBtn.getChildByName("icon"), self.payType, label)
    self.buildPayType(self.discountBtn.getChildByName("icon"), self.discountPayType, disLabel)
    //  设置当前拥有的货币数
    let moneyNode = self.getChildByName("display_silvercoin")
    let txt = moneyNode.getChildByName("txt")
    let moneyNum = 0
    num = moneyNode.getChildByName("num")
    txt.ignoreContentAdaptWithSize(true)
    txt.setPosition(cc.p(txt.getPositionX(), txt.getPositionY() - 5))
    num.ignoreContentAdaptWithSize(true)
    num.setPosition(cc.p(num.getPositionX() + 20, num.getPositionY() - 3))
    self.buildMoneyNum()
}
/**
 * 对指定对象设置货币类型
 * @param node      货币显示节点
 * @param payType   支付方式
 * @param label     价格标签
 */
StartBuyPropPanel.prototype.buildPayType = function(node, payType, label) {
    if (payType === ItemDataManager.PayTypeEnum.Cash) {
        node.setSpriteFrame(UIItemBuilder.createPropIcon(GamePropIds.kCash).getSpriteFrame())
        label.setPositionX(label.getPositionX() + 32)
    } else if (payType === ItemDataManager.PayTypeEnum.Coin) {
        node.setSpriteFrame(UIItemBuilder.createPropIcon(GamePropIds.kCoin).getSpriteFrame())
    } else {
        cc.log("道具货币种类错误！")
    }
}
/**
 * 设置货币数量面板
 */
StartBuyPropPanel.prototype.buildMoneyNum = function() {
    var self = this

    let moneyNode = self.getChildByName("display_silvercoin")
    let moneyNum = 0
    num = moneyNode.getChildByName("num")

    if (self.payType === ItemDataManager.PayTypeEnum.Cash) {
        moneyNode.getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(GamePropIds.kCash).getSpriteFrame())
        moneyNum = UserManager.getInstance().getUserRef().getCash()
    } else if (self.payType === ItemDataManager.PayTypeEnum.Coin) {
        moneyNode.getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(GamePropIds.kCoin).getSpriteFrame())
        moneyNum = UserManager.getInstance().getUserRef().getCoin()
    } else {
        cc.log("道具货币类型错误。")
    }
    if (moneyNum > 100000) {
        moneyNum = Math.floor(moneyNum / 10000) + "万"
    }
    num.setString(moneyNum)
}
/**
 * 道具购买按钮回调
 */
StartBuyPropPanel.prototype.onConfirmBuyProp = function () {
    var self = this

    if (self.isBusy){
        return
    }
    self.isBusy = true

    self.buyItem(self.itemId, 1, self.payType, self.prop)
    //self.onClose()
    //if (self.onConfirm) {
    //    self.onConfirm()
    //}
    DCAssist.userTrack("stage_start", "click_buy", {
        type:self.itemId
    });
}
/**
 * 打折道具包购买按钮回调
 */
StartBuyPropPanel.prototype.onConfirmBuyDiscountProp = function () {
    var self = this

    if (self.isBusy){
        return
    }
    self.isBusy = true

    self.buyItem(self.discountItemId, 1, self.discountPayType, self.discountProp)
    //self.onClose()
    //if (self.onConfirm) {
    //    self.onConfirm()
    //}
    DCAssist.userTrack("stage_start", "click_buy", {
        type:self.discountItemId
    });
}
/**
 * 关闭按钮回调
 */
StartBuyPropPanel.prototype.onCloseClicked = function () {
    var self = this

    if (self.isClose) {
        return
    }
    self.isClose = true

    self.onClose()
    if (self.onCloseCallback) {
        if (self.buySuccess) {
            self.onCloseCallback(true)
        } else {
            self.onCloseCallback()
        }
    }
    //  打点
    DCAssist.userTrack("stage_start", "close_page");
}
StartBuyPropPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    // cc.warn("TODO: unload res list")
    //let preload_list = buildResList(preload_res)
    //unloadResList(preload_list)
    //let index = preload_res.indexOf(extra_plist)
    //if (index !== -1) {
    //    preload_res.splice(index,1)
    //}
}
StartBuyPropPanel.prototype.onEnterAnimFinish = function() {
    var self = this
    self.allowClickEmptyClose = true
    // console.log("self.allowClickEmptyClose", self.allowClickEmptyClose)
}

StartBuyPropPanel.prototype.onClickEmpty = function () {
    var self = this
    
    if (self.isClose || self.isBusy || !self.allowClickEmptyClose) {
        return
    }
    self.isClose = true
    
    self.onClose()
    if (self.onCloseCallback) {
        if (self.buySuccess) {
            self.onCloseCallback(true)
        } else {
            self.onCloseCallback()
        }
    }
    //  打点
    DCAssist.userTrack("stage_start", "close_page");
}
/**
 * 发送购买请求
 * @param itemId    道具编号
 * @param num       道具数量
 * @param payType   付款方式
 * @param node      图标所属Node，用来播放购买成功动画的时候计算坐标使用
 */
StartBuyPropPanel.prototype.buyItem = function (itemId, num, payType, node) {
    var self = this

    var userDealPayType = UserDealPayType.kCoin
    if (payType === ItemDataManager.PayTypeEnum.Cash) {
        userDealPayType = UserDealPayType.kCash
    }
    function onSuccess(evt) {
        //  购买承购打标记
        self.buySuccess = true
        //  刷新货币数量
        self.buildMoneyNum()
        self.playSuccessAnim(itemId, num, node, function () {
            Toast.make(getText("购买成功"), null, () => {
                self.isBusy = false
            })
        })
        //  购买成功打点
        DCAssist.userTrack("stage_start", "buy_success", {
            type: itemId
        });
        self.isBusy = false
    }
    function onFailed(evt) {
        //  检查是否为银币不足
        if (evt.data === ZooErrorCode.COIN_NOT_ENOUGH) {
            //  启动银币不足逻辑
            require("clover/panel/CoinNotEnoughPanel").show(true, function () {
                self.isBusy = false
                self.setHideState(false)
                //  刷新货币数量
                self.buildMoneyNum()
            }, ModuleName.STAGE_START) 
            self.setHideState(true)
        } else if (evt.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            //  启动风车币不足逻辑
            require("clover/panel/CashNotEnoughPanel").show(function () {
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab)
                self.isBusy = false
                self.setHideState(false)
            }, function () {
                self.isBusy = false
                self.setHideState(false)
                //  刷新货币数量
                self.buildMoneyNum()
            }, true, ModuleName.STAGE_START)
            self.setHideState(true)
        } else {
            Toast.make(quickGetErrorText(evt.data, getText("购买失败，请稍后重试")), null, () => {})
            self.isBusy = false
        }
        // self.isBusy = false
    }
    //UserDeal.getInstance().buyItem(itemId, num, userDealPayType, null, null, successCallback, failCallback, cancelCallback, ModuleName.STAGE_START)
    UserDeal.getInstance().buyItem(itemId, num, userDealPayType, null, { source: ModuleName.BEFORE_STAGE}, onSuccess, onFailed, onFailed, ModuleName.STAGE_START)
}
StartBuyPropPanel.prototype.playSuccessAnim = function (itemId, num, node, callback) {
    var self = this

    var itemData = ItemDataManager.getItemDataById(itemId)
    var itemConfig = table()
    itemConfig.itemId = itemData.propId
    itemConfig.num = itemData.num * num
    itemConfig.scale = 1.25
    itemConfig.pos = node.convertToWorldSpace(cc.p(node.getContentSize().width / 2, node.getContentSize().height / 2))
    PropBagAnimation.addItemsToBag(table([0, itemConfig]), callback, 0.15)
}
/**
 * 设置隐藏状态
 * @param state 是否切换到隐藏
 */
StartBuyPropPanel.prototype.setHideState = function (state) {
    var self = this

    var fromScale = self.getScale()  
    var targetScale = 0
    if (state) {
        //  隐藏面板
        fromScale = self.getScale()
        targetScale = 0
    } else {
        //  显示面板
        fromScale = 0
        targetScale = self.originScale
    }
    var time = 7 / 30
    var basePanel = self
    var vSize = cc.Director.getInstance().getVisibleSize()
    var centerPos = cc.p(vSize.width / 2, vSize.height / 2)
    
    var size = basePanel.getContentSize()
    var oneScalePos = cc.p(centerPos.x - size.width / 2, centerPos.y + size.height / 2)
    var fromPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), fromScale))
    var targetPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), targetScale))
    var midPoint = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), targetScale * 1.16))
    basePanel.setScale(fromScale)
    basePanel.setPosition(fromPos)
    basePanel.runAction(
        cc.Sequence.create(
            cc.Spawn.create(
                cc.EaseSineOut.create(
                    cc.ScaleTo.create(time * 2 / 3, targetScale * 1.16)
                ),
                cc.EaseSineOut.create(cc.MoveTo.create(time * 2 / 3, midPoint))
            ), cc.Spawn.create(
                cc.EaseSineIn.create(cc.ScaleTo.create(time / 3, targetScale)),
                cc.EaseSineIn.create(cc.MoveTo.create(time / 3, targetPos))
            )))
}
module.exports = StartBuyPropPanel
